import { render, staticRenderFns } from "./Webhead.vue?vue&type=template&id=115a8bd0"
import script from "./Webhead.vue?vue&type=script&lang=js"
export * from "./Webhead.vue?vue&type=script&lang=js"
import style0 from "./Webhead.vue?vue&type=style&index=0&id=115a8bd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports